import {LanguagesInterface, responseInterface, urlsInterface} from "@/types";
import {
  httpClient,
  HttpClientGetParameters,
  HttpClientPostParameters,
} from "@/apiClient/models/http/httpClient.models";

export interface LanguagesApiClientInterface {
  fetch: () => Promise<responseInterface>;
  post: () => Promise<LanguagesInterface[]>;
}

export class LanguagesApi implements LanguagesApiClientInterface {
  private readonly urls!: urlsInterface;

  constructor(urls: urlsInterface) {
    this.urls = urls;
  }

  fetch(): Promise<responseInterface> {
    const getParameters: HttpClientGetParameters = {
      url: this.urls.fetch,
      requiresToken: false,
    };

    return httpClient.get<responseInterface>(getParameters);
  }

  post(): Promise<LanguagesInterface[]> {
    const PostParameters: HttpClientPostParameters = {
      url: JSON.stringify(this.urls.post),
      payload: {},
      requiresToken: false,
    };

    return httpClient.post<LanguagesInterface[]>(PostParameters);
  }
}
